import type { ActivityProvider } from '@atlassian/activity-provider';
import { ActivityResource as AkActivityResource } from '@atlassian/activity-provider';

const ACTIVITY_URL = '/gateway/api/graphql';

export type ActivityResourceType = ActivityProvider;

export async function getActivityProvider(cloudId: string): Promise<ActivityResourceType> {
	return Promise.resolve(new AkActivityResource(ACTIVITY_URL, cloudId));
}
